import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TranslatedCopy from '../../intl/translated-copy';
import cx from 'classnames';
import { removeCodeError } from '../../../redux/actions/index';
import { get } from 'lodash';

const defaultErrors = [
  '500217',
  '500214',
  '100412',
];
class AlertWarningError extends Component {
  static propTypes = {
    codeInicativeAccount: PropTypes.string,
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(removeCodeError(true));
  }

  render() {
    const { codeInicativeAccount, messageCopyId } = this.props;
    const isCPError = defaultErrors.includes(codeInicativeAccount);
    const showDefaultMessage = codeInicativeAccount === '15530702';
    const message = get(messageCopyId, 'errorMessages[0].errorMessage.copy', false);

    const alertWarningErrorIcon = cx({
      'AlertWarningError-msg-icon-red': true,
      'Icon Icon--Red_Alert': !isCPError,
      'Icon Icon--electricytPlug': isCPError,
    });

    return (
      <div className='AlertWarningError-container'>
        <div aria-hidden='true' className={ alertWarningErrorIcon } />
        <div className='AlertWarningError-msg'>
          { showDefaultMessage &&
            <TranslatedCopy
              className='AlertWarningError-title'
              copyID='PROFILE_INCORRECT_DATA'
            />
          }
          { isCPError
            ? <TranslatedCopy copyID='DESCONEXION_CP_MODAL_LOGIN_SIGNUP' />
            : message && <TranslatedCopy copyID={ message } />
          }
        </div>
      </div>
    );
  }
}

export default AlertWarningError;
